import { useMemo } from 'react';

import { useJourneys, useJourneysByIds } from '../../../../hooks/queries';
import { useTranslation } from '../../../../hooks/useTranslation';
import { useParsedIdsFromStrings } from '../../../../hooks/useParsedIdsFromStrings';
import { dedupeBy } from '../../../../utils/dedupeBy';

type UseJourneyOptionsProps = {
  search: string;
  values: string[] | null;
};

export const useJourneyOptions = ({ search, values }: UseJourneyOptionsProps) => {
  const { t } = useTranslation();
  const selectedIds = useParsedIdsFromStrings(values ?? []);
  const {
    journeys: selectedJourneys,
    didError: didSelectedJourneysError,
    isLoading: isSelectedJourneysLoading,
  } = useJourneysByIds(selectedIds);
  const {
    journeys: suggestedJourneys,
    didError: didSuggestedJourneysError,
    isLoading: isSuggestedJourneysLoading,
  } = useJourneys({ search });

  const isLoading = isSelectedJourneysLoading || isSuggestedJourneysLoading;
  const didError = didSelectedJourneysError || didSuggestedJourneysError;

  const options = useMemo(
    () =>
      dedupeBy([...selectedJourneys, ...suggestedJourneys], 'id').map((journey) => ({
        title: journey.name,
        subtitle: t('v2.conditionBuilder.journeySubtitle', { id: journey.id }),
        value: journey.id.toString(),
      })),
    [selectedJourneys, suggestedJourneys, t],
  );

  return { options, didError, isLoading };
};
